// Middleware
import ActionTypes from "utilization/constants/ActionTypes";

export default (rowId) => ({
  rowId,
  type: ActionTypes.TOGGLE_DETAIL_VISIBILITY,
});
